import { APICore } from './apiCore'

const api = new APICore()

function getCategoriesTravel (params) {
  const baseUrl = '/category-travel'
  return api.get(baseUrl, params)
}

function getCategoryTravel (id) {
  const baseUrl = `/category-travel/${id}`
  return api.get(baseUrl, {})
}

function addCategoryTravel (params) {
  const baseUrl = '/category-travel'
  return api.createWithFile(baseUrl, params)
}

function updateCategoryTravel (params) {
  const baseUrl = '/category-travel'
  return api.updateWithFile(baseUrl, params)
}

function deleteCategoryTravel (params) {
  const baseUrl = '/category-travel'
  return api.delete(baseUrl, params)
}

export { getCategoriesTravel, getCategoryTravel, addCategoryTravel, updateCategoryTravel, deleteCategoryTravel }
